import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { TrustBar } from "./components/TrustBar";
import { Benefits } from "./components/Benefits";
import { Services } from "./components/Services";
import { Reviews } from "./components/Reviews";
import { ContactCTA } from "./components/ContactCTA";
import { Footer } from "./components/Footer";
import { MobileFab } from "./components/MobileFab";

const Landing = () => {
  return (
    <div data-testid="norivet-landing" className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Benefits />
        <Services />
        <Reviews />
        <ContactCTA />
      </main>
      <Footer />
      <MobileFab />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
